import Logger from '../../toolkit/logger/Logger';
import { NameValue } from '../widgets/types';
import http, { URL_ROOT } from '../../services/http-service';

export const normalizeCollections = (collections: any[]) => {
  for (const item of collections) {
    item.enabled = false;
    for (const filter of item.filters) {
      filter.value = undefined;
    }
  }
  Logger.info('normalizeCollections', collections);
  return collections;
}

export const modifyCollectionFilter = (
  collections: any[],
  collectionName: string,
  filter: string,
  value: any
) => {
  const result = collections.map(item => {
    if (item.name === collectionName) {
      item.filters = item.filters.map(f => {
        if (f.name === filter) {
          f.value = value;
        }
        return f;
      });
    }
    return item;
  }).sort((x, y) => y.filters.length - x.filters.length);
  Logger.info('modifyCollectionFilter', result);
  return result;
}

export const hasConflict = (filters: any[], filter: any) => {
  const conflicts = filters.filter(f => f.conflicts && f.conflicts.includes(filter.name))
  for (const item of conflicts) {
    if (item.value !== '' && item.value != null) {
      Logger.info(filter.name, 'has conflict with', item.name);
      return true;
    }
  }
  return false;
}

export const fetchOptions = async (label: string, search: string, searchMap: NameValue, defaultValues: any = []) => {
  const result = defaultValues;
  if (search == null) {
    return result;
  }
  try {
    const { data } = await http.get(URL_ROOT + search);
    if (Array.isArray(data)) {
      result.push(...data.map(item => {
        let name = '';
        if (Array.isArray(searchMap.name)) {
          name = searchMap.name.map(n => item[n]).join(' - ');
        }
        else {
          name = item[searchMap.name];
        }
        return { name, value: item[searchMap.value] };
      }));
    }
  }
  catch (e) {
    console.log('error:', e);
  }
  return result;
}

export const prepareCollections = (collections: any) => {
  const cloned = JSON.parse(JSON.stringify(collections));
  const filtered = cloned.filter(x => x.enabled);
  for (const item of [...filtered]) {
    const newFilters = {};
    for (const f of [...item.filters]) {
      newFilters[f.name] = f.value ?? null;
    }
    item.filters = newFilters;
    delete item.enabled;
  }
  return filtered;
}
